import React, { useState } from 'react'
import '../MainFrame.css';
import "./ayuda.css"

const faqData = [
    {
        q: '¿Cómo uso el menú de navegación?',
        a: 'El menú de navegación se encuentra en el lado izquierdo de cada página. Los enlaces brindan acceso rápido a las funciones del Campus: inicio, calendario, cursadas, administración, buzón y ayuda.'
    },
    {
        q: 'Ver módulos',
        a: 'En Módulos podés ver todos los módulos de tu curso, organizados por orden de progresión. Cada módulo alberga los elementos de contenido correspondientes. Podés expandir o contraer todos los módulos con el botón disponible.'
    },
    {
        q: '¿Quién impulsa la Plataforma de Aprendizaje Virtual?',
        a: 'Todos nuestros cursos fueron generados por el staff de la Dirección de Capacitación en TIC de Fundación 360.'
    },
    {
        q: '¿Qué necesito para cursar?',
        a: 'Además de tu cuenta de Campus 360 no hay requisitos excluyentes. Algunos cursos recomendarán, por su extensión o complejidad, que los realices desde una PC, notebook u otro dispositivo cómodo para realizar las actividades. Prestá atención a las recomendaciones previas al inicio de cada curso.'
    }
];

const Faqs = (props) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

    return (
        <div className='frame faqs-frame'>
            <h2 className='faqs-title'>Preguntas Frecuentes</h2>
            <div className='faqs-list'>
                {faqData.map((item, i) => (
                    <div className={`faq-item${openIndex === i ? ' open' : ''}`} key={i}>
                        <button className='faq-question' onClick={() => toggle(i)}>
                            <span>{item.q}</span>
                            <svg className={`faq-chevron${openIndex === i ? ' rotated' : ''}`} viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 12 15 18 9"/>
                            </svg>
                        </button>
                        {openIndex === i && (
                            <div className='faq-answer'>
                                <p>{item.a}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Faqs;
